import { createSelector } from 'reselect';
import { userSelector } from '@lingoda/auth';

const studentIdSelector = createSelector(userSelector, (user) => user && user.studentId);

export default studentIdSelector;
